/**
 * Firestore user row from phone dev-auth.
 * Treat as a dev account for client tier/usage bypass even if `isDevAccount` is missing (legacy
 * docs) or non-boolean. All synthetic dev-auth emails use the `@dev.local` domain.
 *
 * @param {Record<string, unknown> | null | undefined} userData
 * @returns {boolean}
 */
export function isDevAuthFirestoreUser(userData) {
  if (!userData || typeof userData !== "object") return false;
  if (userData.isDevAccount === true) return true;
  if (userData.isDevAccount === "true") return true;
  const devAuthCode = userData.devAuthCode;
  if (devAuthCode != null && String(devAuthCode).trim() !== "") return true;
  const email = userData.email;
  return (
    typeof email === "string" && email.toLowerCase().endsWith("@dev.local")
  );
}

export default isDevAuthFirestoreUser;
